export default {
  cpfHidden(state) {
    if (state.data.cpf) {
      return state.data.cpf.replace(/(\d{3})/, '###');
    }
    return '';
  },
};
